const HotspotType = {
	OUTSIDE_360_MOVE:'outside360Move',
	OUTSIDE_360_CONFIGURATOR:'outside360Configurator',
	INFO:'info'
};
export default HotspotType;